import React, { useMemo, useState, useCallback, useEffect } from "react";
import { Checkbox, Text, Button, TextField, Field } from "components/commons";
import locale from "localization";
import { initialState as formState } from "./unsatisfactory.state";
import { useForm } from "hooks";
import styles from "../dashboard.module.scss";

const SurveyUnsatisfactoryForm = ({
  initialState = {},
  setStep2,
  setStep2Data,
  setRating,
  setShowSurvey,
  submitData,
}) => {
  const [buttonActionDisabled, setButtonActionDisabled] = useState(false);
  const form = useMemo(() => {
    return formState(initialState);
  }, [initialState]);

  const { fields, modifyField, modifyForm, clearForm, submitForm, getFormValues } = useForm({
    initialState: form,
  });

  useEffect(() => {
    if (
      fields?.poorCrewAssistanceAtStation.value ||
      fields?.portalWasDifficultToUse.value ||
      fields.problemsWithFuelCodes.value ||
      fields?.pricingOrNoValueForMoney.value ||
      fields?.transactionsWereDifficultToTrack.value
    ) {
      setButtonActionDisabled(false);
    } else {
      setButtonActionDisabled(true);
    }

    if (fields?.otherReasons.value) {
      if (fields?.otherReasonsDescription?.value) {
        setButtonActionDisabled(false);
      } else {
        setButtonActionDisabled(true);
      }
    }
  }, [fields]);

  const onChangeOtherReasons = useCallback(
    (name, { value }) => {
      modifyForm({
        [fields?.otherReasons.name]: {
          value,
        },
        [fields?.otherReasonsDescription.name]: {
          value: "",
        },
      });
    },
    [modifyForm, fields?.otherReasons.name, fields?.otherReasonsDescription.name]
  );

  const submit = async () => {
    const params = getFormValues();
    setStep2Data({ ...params });
    setStep2(true);
  };
  const onSkip = async () => {
    const params = getFormValues();
    submitData({ isSkip: true, ...params });
    clearForm();
    setStep2Data({});
    setStep2(false);
    setRating(0);
    setShowSurvey(false);
  };

  return (
    <>
      <Text className={styles.headerTitleRating}>{locale.whatMadePriceLOCQUnsatisfactory}</Text>
      <div className={styles.checkBoxContainer}>
        <div className={styles.checkBoxLabel}>
          <Checkbox
            {...fields?.poorCrewAssistanceAtStation}
            value={fields.poorCrewAssistanceAtStation.value || null}
            onChange={modifyField}
          />
          <Text className={styles.description}>{locale.poorCrewAssistanceAtStation}</Text>
        </div>
      </div>
      <div className={styles.checkBoxContainer}>
        <div className={styles.checkBoxLabel}>
          <Checkbox
            {...fields?.portalWasDifficultToUse}
            value={fields.portalWasDifficultToUse.value || null}
            onChange={modifyField}
          />
          <Text className={styles.description}>{locale.portalWasDifficultToUse}</Text>
        </div>
      </div>
      <div className={styles.checkBoxContainer}>
        <div className={styles.checkBoxLabel}>
          <Checkbox
            {...fields?.problemsWithFuelCodes}
            value={fields.problemsWithFuelCodes.value || null}
            onChange={modifyField}
          />
          <Text className={styles.description}>{locale.problemsWithFuelCodes}</Text>
        </div>
      </div>
      <div className={styles.checkBoxContainer}>
        <div className={styles.checkBoxLabel}>
          <Checkbox
            {...fields?.pricingOrNoValueForMoney}
            value={fields.pricingOrNoValueForMoney.value || null}
            onChange={modifyField}
          />
          <Text className={styles.description}>{locale.pricingOrNoValueForMoney}</Text>
        </div>
      </div>
      <div className={styles.checkBoxContainer}>
        <div className={styles.checkBoxLabel}>
          <Checkbox
            {...fields?.transactionsWereDifficultToTrack}
            value={fields.transactionsWereDifficultToTrack.value || null}
            onChange={modifyField}
          />
          <Text className={styles.description}>{locale.transactionsWereDifficultToTrack}</Text>
        </div>
      </div>
      <div className={styles.checkBoxContainer}>
        <div className={styles.checkBoxLabelOther}>
          <div className={styles.checkBoxLabelHeader}>
            <Checkbox
              {...fields?.otherReasons}
              value={fields?.otherReasons?.value || null}
              onChange={(name, value) => {
                onChangeOtherReasons(name, value);
              }}
            />
            <Text className={styles.description}>{locale.otherReasons}</Text>
          </div>
          {fields?.otherReasons?.value && (
            <div className={styles.checkBoxLabelFooter}>
              <Field {...fields?.otherReasonsDescription}>
                <TextField {...fields?.otherReasonsDescription} onChange={modifyField} />
              </Field>
            </div>
          )}
        </div>
      </div>
      <div className={styles.skipAndSubmitSatisfactory}>
        <div className={styles.skipSatisfactory}>
          <Button className={styles.skip} onClick={() => submitForm(onSkip)}>
            {locale.skip}
          </Button>
        </div>
        <div className={styles.submitSatisfactory}>
          <Button
            className={styles.continue}
            survey
            disabled={buttonActionDisabled}
            onClick={() => submitForm(submit)}
          >
            {locale.submit}
          </Button>
        </div>
      </div>
    </>
  );
};

export default SurveyUnsatisfactoryForm;
